import { createActions, createReducer } from 'reduxsauce'

const { Types, Creators } = createActions({
  youtubeQuotaRequest: null,
  youtubeQuotaSuccess: ['data'],
  youtubeQuotaFailure: ['error'],
})

export const YoutubeTypes = Types
export const YoutubeActions = Creators

const INITIAL_STATE = {
  loading: false,
  quota: null,
  error: null,
}

const request = (state) => ({
  ...state, loading: true, quota: null, error: null,
})

const success = (state, action) => ({
  ...state, loading: false, quota: action.data,
})

const failure = (state, action) => ({
  ...state, loading: false, error: action.error,
})

export default createReducer(INITIAL_STATE, {
  [Types.YOUTUBE_QUOTA_REQUEST]: request,
  [Types.YOUTUBE_QUOTA_SUCCESS]: success,
  [Types.YOUTUBE_QUOTA_FAILURE]: failure,
})
